// Copyright (c) 2023-2025 Matthias von Laer
// This file is part of Carsharing and is licensed under GNU Affero General Public License 3.0 or any later version. 

import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from "react-oidc-context";
import './index.css';
import App from './App';
import {OIDC_URL} from './Environment.js';
import {ErrorBoundary} from './ErrorBoundary.js';
import reportWebVitals from './reportWebVitals';

console.log(window.location.pathname);
console.log(location.origin);
const onSigninCallback = (user) => {
  window.history.replaceState(
    {},
    document.title,
    window.location.pathname
  );
}
const client = "Carsharing";
const realm = "Carsharing";

const oidcConfig = {
  authority: `${OIDC_URL}/${realm}`,
  client_id: client,
  redirect_uri: location.origin,
  post_logout_redirect_uri: location.origin,
  onSigninCallback: onSigninCallback
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
